import { render, staticRenderFns } from "./ProductClass.vue?vue&type=template&id=14d8879d&scoped=true&functional=true"
import script from "./ProductClass.vue?vue&type=script&lang=js"
export * from "./ProductClass.vue?vue&type=script&lang=js"
import style0 from "./ProductClass.vue?vue&type=style&index=0&id=14d8879d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "14d8879d",
  null
  
)

export default component.exports